module.exports = __webpack_public_path__ + "static/media/Buffalo_Sabres.8e4bfa5b.svg";